import { isEmailChannel } from "../../channels/types";
import { convertLexicalDesign } from "../../moment/component/channel/utils/convert-lexical-design";

import type { ChannelName } from "../../channels/types";
import type { SerialisedLexicalEditorDesign } from "../../message/editor/types/serialised-editor-design";
import type { FollowUpChannelWithData } from "./schema";

export function switchChannel(
  previousChannel: ChannelName,
  newChannel: FollowUpChannelWithData,
  design: SerialisedLexicalEditorDesign | null,
  slackVideoEnabled: boolean,
): FollowUpChannelWithData & { design: SerialisedLexicalEditorDesign | null } {
  // If there is no design, nothing to convert
  if (!design) return { ...newChannel, design: null };

  if (!previousChannel) return { ...newChannel, design };

  if (previousChannel === newChannel.channel) return { ...newChannel, design };

  if (isEmailChannel(previousChannel) && isEmailChannel(newChannel.channel)) {
    // Both channels are email, no conversion needed
    return { ...newChannel, design };
  }

  return {
    ...newChannel,
    design: convertLexicalDesign(previousChannel, newChannel.channel, design, slackVideoEnabled),
  };
}
